module.exports = __webpack_public_path__ + "static/media/customer-haldirams.3154172e.png";